module.exports = {"header":{"portalName":"uMotif 포털"},"message":{"error":{"default":"죄송합니다. 오류가 발생했습니다.","invalidCode":"잘못된 코드가 입력되었습니다. 다시 시도해 주세요."}}}